
interface UserStatsProps {
  totalUsers: number;
  activeUsers: number;
}

export function UserStats({ totalUsers, activeUsers }: UserStatsProps) {
  return (
    <div className="text-sm text-muted-foreground mb-4">
      {totalUsers} users total • {activeUsers} active
    </div>
  );
}
